import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CookieService {

    constructor() { }

    setCookie(name: string, value: string, days: number = 7, path: string = '/'): void {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;

        // Only add Secure flag in production (HTTPS)
        const isSecure = window.location.protocol === 'https:';
        const secureFlag = isSecure ? ';Secure' : '';

        const cookieString = `${name}=${value};${expires};path=${path};SameSite=Lax${secureFlag}`;
        console.log('Setting cookie:', name, 'Protocol:', window.location.protocol);
        document.cookie = cookieString;

        // Verify cookie was set
        const verifySet = this.getCookie(name);
        console.log('Cookie set verification:', name, verifySet ? 'SUCCESS' : 'FAILED');
    }

    getCookie(name: string): string | null {
        const nameEQ = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1, cookie.length);
            }
            if (cookie.indexOf(nameEQ) === 0) {
                const value = cookie.substring(nameEQ.length, cookie.length);
                return value;
            }
        }
        return null;
    }


    deleteCookie(name: string, path: string = '/'): void {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};`;
    }

    /**
     * Check if a cookie exists
     * @param name Cookie name
     * @returns True if cookie exists, false otherwise
     */
    hasCookie(name: string): boolean {
        return this.getCookie(name) !== null;
    }

    /**
     * Clear all cookies
     */
    clearAllCookies(): void {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            this.deleteCookie(name.trim());
        }
    }
}

